import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { Color, theme } from '../../constants'
import { Flex } from '../Flex'
import { Icon, IconName } from '../Icon'

const RightSlot = styled.div({
  marginLeft: 'auto',
  paddingLeft: theme.spacing['3.5'],
  color: Color.DARK_GREY,
  '[data-highlighted] > &': { color: Color.CHARCOAL },
})

type ItemContentProps = {
  children: string
  icon: IconName
  rightSlot?: ReactNode
}

export const ItemContent = (props: ItemContentProps) => {
  return (
    <Flex gap={2} items="center">
      <Icon name={props.icon} color={Color.DARK_GREY} size="sm" />
      <p>{props.children}</p>
      <RightSlot>{props.rightSlot}</RightSlot>
    </Flex>
  )
}
